import 'rxjs/add/operator/switchMap';

export class MathService {

    constructor() { }

    private answers: any[];
    private correct: any;

    private Math = [
        {
            "number": 1,
            "description": "Si el 20% de A es el 50% de B, ¿qué porcentaje de B es A?",
            "options": [
                { "description": "a) 20%", "value": "a" },
                { "description": "b) 40%", "value": "b" },
                { "description": "c) 250%", "value": "c" },
                { "description": "d) 400%", "value": "d" }
            ],
            "answer": "c"
        },
        {
            "number": 2,
            "description": "Juan necesita comprar 40/9 de kg de azúcar. Si cada kg de azúcar cuesta lo mismo que 9/10 de billete de $20, ¿cuánto dinero gastará?",
            "options": [
                { "description": "a) $36", "value": "a" },
                { "description": "b) $48", "value": "b" },
                { "description": "c) $80", "value": "c" },
                { "description": "d) $88", "value": "d" }
            ],
            "answer": "c"
        },
        {
            "number": 3,
            "description": "¿Cuál es el valor de x en la siguiente ecuación?  1/6^x = (2^(x-1) )*(3^(x-1) )",
            "options": [
                { "description": "a) 0", "value": "a" },
                { "description": "b) 1/2", "value": "b" },
                { "description": "c) 1", "value": "c" },
                { "description": "d) 2", "value": "d" }
            ],
            "answer": "b"
        },
        {
            "number": 4,
            "description": "Iván ha estado enamorado de Eleonor desde que tenía 7 años, aunque ella es 3 años menor, hoy después de 18 años al fin se casarán. Si entre 5 organizadores pueden arreglar 12 mesas de invitados en horas, ¿cuántos organizadores más se necesitan para arreglar 36 mesas en 6 horas?",
            "options": [
                { "description": "a) 0", "value": "a" },
                { "description": "b) 5", "value": "b" },
                { "description": "c) 8", "value": "c" },
                { "description": "d) 15", "value": "d" }
            ],
            "answer": "a"
        },
        {
            "number": 5,
            "description": "Si a☻b es igual al producto del doble del cuadrado de a y una quinta parte del cuadrado de b, ¿a cuánto es igual 3☻5?",
            "options": [
                { "description": "a) 450", "value": "a" },
                { "description": "b) 90", "value": "b" },
                { "description": "c) 88", "value": "c" },
                { "description": "d) 15", "value": "d" }
            ],
            "answer": "b"
        },
    ];

    private explications = [
      {
        "description": "https://www.youtube.com/embed/Dc51iN0vBjY",
      },

      {
        "description": "https://www.youtube.com/embed/_tzNjlID024",
      },

      {
        "description": "https://www.youtube.com/embed/uOAQVEPJ5fw",
      },

      {
        "description": "https://www.youtube.com/embed/Sw3XjGp_mMg",
      },

      {
        "description": "https://www.youtube.com/embed/AyyjUezFRAE",
      },
    ];

    getQuestion() {
        return this.Math;
    }

    getAnswers() {
        return this.answers;
    }

    getExplications() {
      return this.explications;
    }

    setCorrectAnswers(corects: any) {
      // console.log("Recibio Mate", corects);
      this.correct = corects;
    }

    getCorrectAnswers() {
      // console.log("Envio Mate", this.correct);
        return this.correct;
    }

    setAnswers(aux: any[]) {
        this.answers = aux;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/math.service.ts